import { PortalAuthConfig } from "./partner_config";

interface PortalAuth {
  development: PortalAuthConfig;
  staging: PortalAuthConfig;
  production: PortalAuthConfig;
}
export const portalAuth = (partnerSlug: string): PortalAuth => ({
  development: {
    domain: "flexspace-partners-portal-dev.us.auth0.com",
    audience: "https://api.flexspace-partners-portal-dev.ai",
    clientId: "jv7koW8B8g6t7SXot6nVwLjaza4IeZLb",
    redirectUri: `${window.location.origin}/portal/auth/callback?partnerSlug=${partnerSlug}`,
  },
  staging: {
    domain: "flexspace-partners-portal-staging.us.auth0.com",
    clientId: "SIlGnPSJkPe6j4FYG2RL74Qzz5cTz3rZ",
    audience: "https://api.flexspace-partners-portal-staging.ai",
    redirectUri: `${window.location.origin}/portal/auth/callback?partnerSlug=${partnerSlug}`,
  },
  production: {
    domain: "flexspace-partners-portal.us.auth0.com",
    clientId: "NkFtQP1lCuNaY4qb9NDKllet5Os3zBst",
    audience: "https://api.flexspace-partners-portal.ai",
    redirectUri: `${window.location.origin}/portal/auth/callback?partnerSlug=${partnerSlug}`,
  },
});
